import { render, staticRenderFns } from "./Leftbar.vue?vue&type=template&id=407c2317&"
import script from "./Leftbar.vue?vue&type=script&lang=ts&"
export * from "./Leftbar.vue?vue&type=script&lang=ts&"
import style0 from "./Leftbar.vue?vue&type=style&index=0&id=407c2317&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports